<template>
  <div class="button-dropdown-item">
    <router-link
      :to="to"
      class="item item--link"
      v-if="type === 'link'"
    ><slot></slot></router-link>
    <button class="item item--button" v-if="type === 'button'" @click="$emit('click', $event)"><slot></slot></button>
  </div>
</template>

<script>
export default {
  name: 'ButtonDropdownItem',

  props: {
    type: {
      type: String,
      required: false,
      default: 'link',
    },
    to: {
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .button-dropdown-item {
    .item {
      @apply block;
      @apply px-4;
      @apply py-2;
      @apply text-gray-800;
      @apply w-full;
      @apply text-left;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
</style>
